<script setup lang="ts">
  import { SfIconFacebook, SfIconInstagram, SfIconLinkedin, SfIconTwitterX, SfIconPinterest, SfIconSnapchat, SfIconTiktok, SfIconYoutube } from '@storefront/components';
  import { useShared } from '@othercommerce/foundation';

  type IconName = keyof typeof iconComponents;

  const shared = useShared();
  const socials = shared.value.socialMediaProfiles;
  const iconComponents = {
    SfIconFacebook,
    SfIconInstagram,
    SfIconLinkedin,
    SfIconTwitterX,
    SfIconTiktok,
    SfIconPinterest,
    SfIconSnapchat,
    SfIconYoutube,
  };
</script>
<template>
  <div v-if="socials && socials.length" class="footer-socials-media">
    <div class="container">
      <div class="footer-socials-media__wrapper">
        <SfButton
          v-for="profile in socials"
          :key="profile.id"
          :href="profile.link"
          target="_blank"
          rel="noopener noreferrer nofollow"
          class="footer-socials-media__link"
          :aria-label="profile.platform"
          square
        >
          <component :is="iconComponents[profile.icon as IconName]" />
        </SfButton>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .footer-socials-media {
    &__wrapper {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
    }
  }
</style>